import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import "typeface-poppins";
import "typeface-raleway";

const AnimatedWord = ({ word, index, isVisible, isBold }) => {
  const [isWhite, setIsWhite] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timeout = setTimeout(() => {
        setIsWhite(true);
      }, index === 0 ? 0 : index * 100);

      return () => clearTimeout(timeout);
    }
  }, [isVisible, index]);

  return (
    <span
      style={{
        color: isWhite ? "#FFFFFF" : "#515151",
        transition: "color 0.5s ease",
        display: "inline-block",
        marginRight: "8px",
        fontSize: "33px",
        fontWeight: isBold ? "bold" : "normal",
      }}
    >
      {word}
    </span>
  );
};

const AnimatedText = ({ text, isVisible }) => {
  const boldWords = [
    "TowerWatch-",
    "innovative",
    "tools, ",
    "energy-efficiency ",
    "improvement,",
    "cost-cutting,",
    "and ecological",
    "solution",
    "champions.",
  ];

  return (
    <div style={{ display: "inline" }}>
      {text.split("\n").map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {line.split(" ").map((word, wordIndex) => (
            <AnimatedWord
              key={`${lineIndex}-${wordIndex}`}
              word={word}
              index={lineIndex * 10 + wordIndex} // Unique animation delay per word
              isVisible={isVisible}
              isBold={boldWords.includes(word)}
            />
          ))}
          <br /> {/* Add a line break after each line */}
        </React.Fragment>
      ))}
    </div>
  );
};

const Page4 = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.3) {
          setIsVisible(true);
        }
      },
      { threshold: [0.3] }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const text = `
Discover TowerWatch-

Your ultimate ally in sustainable building energy management.
Join our waiting list 
 to be the first one 
to explore the 
innovative tools, 
energy-efficiency 
improvement, 
cost-cutting, and ecological 
solution 
champions.`;

  return (
    <Box
      ref={sectionRef}
      sx={{
        backgroundColor: "black",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "start",
        padding: { xs: "20px", sm: "40px" }, // Responsive padding for mobile
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#000",
          padding: { xs: "1rem", sm: "2rem" }, // Responsive padding for mobile
          textAlign: "left",
          fontFamily: "Raleway",
          fontSize: { xs: "24px", sm: "33px" }, // Responsive font size
          width: { xs: "100%", sm: "702px" }, // Width adjustment for mobile
          position: "relative",
          overflow: "hidden",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 1.5s ease, transform 1.5s ease",
        }}
      >
        {/* Text Layer */}
        <Box sx={{ position: "relative", zIndex: 2 }}>
          <Typography sx={{ fontSize: { xs: "20px", sm: "33px" }, lineHeight: "1.5" }}>
            <AnimatedText text={text} isVisible={isVisible} />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Page4;
